export type ReportPostType = 'reports' | 'reports_retivut';

const REPORTAN_WEB_ORIGIN = 'https://reportan.co.il';

/** Reportan Web editor route for a report stored by `storeReport` (adr/publish-angular-reports-to-firestore-only.md). */
export function reportanReportUrl(postType: ReportPostType, reportId: string): string {
  const reportType = postType === 'reports' ? 'bedek' : 'retivut';
  return `${REPORTAN_WEB_ORIGIN}/${reportType}/${encodeURIComponent(reportId)}`;
}
